import { render, staticRenderFns } from "./BagItem.vue?vue&type=template&id=791ed36e&scoped=true&"
import script from "./BagItem.vue?vue&type=script&lang=js&"
export * from "./BagItem.vue?vue&type=script&lang=js&"
import style0 from "./BagItem.vue?vue&type=style&index=0&id=791ed36e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791ed36e",
  null
  
)

export default component.exports